"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("@xstyled/styled-components"));
var system_1 = require("@xstyled/system");
var Divider = styled_components_1.default.li(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 1px;\n  border-top: 1;\n  border-top-color: grays.3;\n  border-bottom: 1;\n  border-bottom-color: ", ";\n\n  width: 98%;\n  margin-left: 2;\n"], ["\n  height: 1px;\n  border-top: 1;\n  border-top-color: grays.3;\n  border-bottom: 1;\n  border-bottom-color: ", ";\n\n  width: 98%;\n  margin-left: 2;\n"])), system_1.th('colors.white'));
Divider.displayName = 'List.Divider';
exports.default = Divider;
var templateObject_1;
//# sourceMappingURL=ListDivider.js.map